import { Component, Input } from '@angular/core';
import { EllipsisComponent } from '@forgerock/backstage-ui-components';

@Component({
  selector: 'app-search-result-snippet',
  templateUrl: './search-result-snippet.component.html',
  styleUrls: [ './search-result-snippet.component.scss' ],
  imports: [
    EllipsisComponent
  ]
})
export class SearchResultSnippetComponent {
  @Input() snippet: string;
  @Input() synopsis: string;
}
